export default __webpack_public_path__ + "static/iphone-81b7ab42fca8fd202a82d257ac2ef0ec.webp";